import React from 'react';
import Icon from '../../../../muiComponents/Icon';
import {
    getSupplierTaxCalculationRuleTypeSubTypes,
    supplierTaxCalculationRuleTypeFrequencyIcons,
    supplierTaxCalculationRuleTypeSubjectIcons,
    UnknownOptionIcons,
} from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import useTranslate from '../../../../customHooks/useTranslate';

interface ISupplierTaxCalculationRuleTypeIconProps {
    entityKey: string;
    type: 'subject' | 'frequency';
}

const SupplierTaxCalculationRuleTypeIcon = ({
    entityKey,
    type,
}: ISupplierTaxCalculationRuleTypeIconProps) => {
    const translate = useTranslate();
    const supplierTaxCalculationRuleTypeSubIcons =
        getSupplierTaxCalculationRuleTypeSubTypes(entityKey);

    const typeIcon = {
        subject: supplierTaxCalculationRuleTypeSubIcons.subject
            ? supplierTaxCalculationRuleTypeSubjectIcons[
                  supplierTaxCalculationRuleTypeSubIcons.subject as keyof typeof supplierTaxCalculationRuleTypeSubjectIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_SUBJECT_TYPE,
        frequency: supplierTaxCalculationRuleTypeSubIcons.frequency
            ? supplierTaxCalculationRuleTypeFrequencyIcons[
                  supplierTaxCalculationRuleTypeSubIcons.frequency as keyof typeof supplierTaxCalculationRuleTypeFrequencyIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_FREQUENCY_TYPE,
    };

    return (
        <Tooltip
            title={`${translate(
                type === 'subject' ? 'applies_by' : 'frequency'
            )}: ${supplierTaxCalculationRuleTypeSubIcons[type] || ''}`}
        >
            <span className='flex gap-5 flex-align-center'>
                <Icon iconName={typeIcon[type]} />
            </span>
        </Tooltip>
    );
};

export default SupplierTaxCalculationRuleTypeIcon;
